<template>
  <div>
    <div class="button-area">
      <Button @click="back()" class="button-right">返回</Button>
    </div>
   
      <Form
        :model="tqtAppeal"
        inline
        style="width: 1000px;margin:0 auto;"
        :label-width="130"
        label-position="left"
      >
      <FormItem label="企业信息">
      </FormItem>
      <br>
        <FormItem label="企业名称">
          <Input
            readonly
            style="width: 320px;"
            class="query-model"
            placeholder="企业名称"
            v-model="model.name"
          ></Input>
        </FormItem>
        <br>
        <FormItem label="统一社会信用代码">
          <Input
            readonly
            style="width: 320px"
            class="query-model"
            placeholder="企业名称"
            v-model="model.code"
          ></Input>
        </FormItem>
        <br>
        <FormItem label="联系人">
          <Input
            readonly
            style="width: 320px"
            class="query-model"
            placeholder="联系人"
            v-model="model.concat"
          ></Input>
        </FormItem>
        <br>
        <FormItem label="联系方式">
          <Input
            style="width: 320px"
            readonly
            class="query-model"
            placeholder="联系方式"
            v-model="model.phone"
          ></Input>
        </FormItem>
        <br>
        <FormItem label="存量贷款情况">
        </FormItem>
        <br>
        <FormItem label="金额">
          <Input
            style="width: 320px"
            readonly
            class="query-model"
            placeholder="联系方式"
            v-model="model.cldkMoney"
          ></Input>
        </FormItem>
        <br>
        <FormItem label="合作银行">
          <Input
            style="width: 320px"
            readonly
            class="query-model"
            placeholder="合作银行"
            v-model="model.cldkhzyh"
          ></Input>
        </FormItem>
        <br>
        <FormItem label="处置意向">
          <Input
            style="width: 320px"
            readonly
            class="query-model"
            placeholder="处置意向"
            v-model="model.czyx"
          ></Input>
        </FormItem>
        <br>
          <FormItem label="新增贷款情况">
        </FormItem>
        <br>
         <FormItem label="金额">
          <Input
            style="width: 320px"
            readonly
            class="query-model"
            placeholder="处置意向"
            v-model="model.xzdkMoney"
          ></Input>
        </FormItem>
        <br>
         <FormItem label="合作银行">
          <Input
            style="width: 320px"
            readonly
            class="query-model"
            placeholder="合作银行"
            v-model="model.xzdkhzyh"
          ></Input>
        </FormItem>
       
      </Form>

    
  </div>
</template>

<script>
import util from "@/libs/util.js";

export default {
  name: "tqtAppealForm2",
  data() {
    return {
      feedbackunit: "",
      feedbackcontent: "",
      modal1: false,
      //ID
      id: null,
      saveLoading: false,
      //表单参数
      model: {
        name: "",
        companyid: null,
        id: null,
        type: null,
        code: null,
        concat: null,
        phone: null,
        email: null,
        content: null,
        pic: null,
        gz: null,
        num: null,
        money: null,
        cldkmoney: null,
        cldkhzyh: null,
        czyx: null,
        xzdkmoney: null,
        xzdkhzyh: null,
        status: null,
        userid: null,
        feedbackcontent: null,
        appealtype: null,
        createtime: null,
        updatetime: null,
      },
    };
  },
  mounted() {
    if (
      typeof this.$route.query.id !== "undefined" &&
      this.$route.query.id !== null &&
      this.$route.query.id !== ""
    ) {
      this.id = this.$route.query.id;
      //ID存在渲染表单
      this.initForm();
    }
  },
  methods: {
    //修改日期格式
    formatTime(UTCDateString) {
      if (!UTCDateString) {
        return "-";
      }

      function formatFunc(str) {
        //格式化显示
        return str > 9 ? str : "0" + str;
      }

      var date2 = new Date(UTCDateString); //这步是关键
      var year = date2.getFullYear();
      var mon = formatFunc(date2.getMonth() + 1);
      var day = formatFunc(date2.getDate());
      var hour = date2.getHours();
      var min = formatFunc(date2.getMinutes());
      var second = formatFunc(date2.getSeconds());
      var dateStr = year + "-" + mon + "-" + day;
      return dateStr;
    },
    //反馈
    ok() {
      let _this = this;
      util.http
        .put("api/updateByPrimaryKey", {
          feedbackunit: _this.feedbackunit,
          feedbackcontent: _this.feedbackcontent,
          id: _this.$route.query.id,
          userId: _this.$route.query.userId,
        })
        .then((response) => {
          if (response.status === 200) {
            _this.$Notice.success({
              title: "提交成功",
            });
            _this.model.status = 1;
          } else {
            _this.$Notice.error({
              title: "提交失败",
            });
          }
        });
    },
    //保存
    save() {
      if (this.id) {
        this.update();
      } else {
        this.create();
      }
    },

    create() {
      let _this = this;
      _this.saveLoading = true;
      util.http
        .post("/api/tqtAppeals", this.model, {
          headers: {
            "Content-Type": "application/json",
          },
        })
        .then(function (response) {
          _this.$Notice.success({
            title: "保存成功!",
          });
          _this.back();
        })
        .catch(function (error) {
          _this.$Notice.error({
            title: "保存失败!",
          });
          _this.saveLoading = false;
          console.log(error);
        });
    },

    update() {
      let _this = this;
      _this.saveLoading = true;
      util.http
        .put("/api/tqtAppeals", this.model, {
          headers: {
            "Content-Type": "application/json",
          },
        })
        .then(function (response) {
          _this.$Notice.success({
            title: "更新成功!",
          });
          _this.back();
        })
        .catch(function (error) {
          _this.$Notice.error({
            title: "更新失败!",
          });
          _this.saveLoading = false;
          console.log(error);
        });
    },

    //渲染表单
    initForm() {
      let _this = this;
      util.http
        .get("/api/tqtAppeals/" + this.id)
        .then(function (response) {
          let tem = response.data;
          (_this.model.name = tem.name),
            (_this.model.type = tem.appealTypeName),
            (_this.model.concat = tem.concat),
            (_this.model.phone = tem.phone),
            (_this.model.area = tem.area),
            (_this.model.createTime = _this.formatTime(tem.createTime)),
            (_this.model.updateTime = tem.updateTime),
            (_this.model.content = tem.content),
            (_this.model.pic = tem.pic);
            (_this.model.cldkMoney = tem.cldkMoney);
            (_this.model.cldkhzyh = tem.cldkhzyh);
            (_this.model.code = tem.code);
            (_this.model.czyx = tem.czyx);
            (_this.model.xzdkMoney = tem.xzdkMoney);
            (_this.model.xzdkhzyh = tem.xzdkhzyh);
        })
        .catch(function (error) {
          _this.$Notice.error({
            title: "获取表单失败!",
          });
          console.log(error);
        });
    },

    //返回,需要自定义配置路由
    back() {
      this.$store.commit('app/closePage', {
          vm: this,
          route:{
            name:'tqt_appeal',
            query:{
              tabName:'name3'
            }
          }
      })
    },
  },
};
</script>

<style scoped>
.button-area {
  display: flex;
  justify-content: flex-end;
}

.button-right-left {
  margin-right: 15px;
}

.button-right {
  margin-right: 55px;
}

.form-area {
  margin-top: 40px;
  display: flex;
  justify-content: center;
}

.form-flex {
  display: flex;
  justify-content: space-between;
}

.model-hidden {
  display: none;
}
</style>
